
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import styles from './Tenants.module.css'
import { orderColumns } from './serverColumns'
import { EditableList } from '../../compnents/list/EditableList'
import {
  Button,
  Form,
  Input,
  Row,
  Space,
  Cascader as Cascaded,
  Select,
  notification,
} from 'antd'
import { CaretDownFilled, SearchOutlined } from '@ant-design/icons'
import {
  getAllList,
  getServerList,
  getOrderPriceList,
  getLabelList
} from './tenantSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { ThemeContext } from '../../theme/ThemeContext'
import { getPlatformIdList } from './serviceDelaySlice'
import {
  getTenantCategoryName,
  TenantCategories,
  TenantCategory,
} from '../../models/tenant'
import {
  DateSelect,
  DateRangeFieldName,
  DateRangeType,
} from '../../compnents/form/DateSelect'
import { stringTrim } from '../../utils/StringUtils'
interface ServerManagementProps {
  state: string
}

export const ServerManagement = ({
  state,
}: ServerManagementProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const theme = useContext(ThemeContext)

  const [pageLoading, setPageLoading] = useState(false)

  const [params, setParams] = useState<any>({
    current: 0,
    size: 10,
  })

  console.log(state, 'state')

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [allList, setAllList] = useState<any[]>() //省市数据

  const [productPriceModalList, setProductPriceModalList] = useState([]) //产品价格表弹窗数据

    const [platformIdOptions, setPlatformIdOptions] = useState<any>([])

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname) || '{}'
  ) //当前页面缓存数据

  const loadData = (selectedOptions: any) => {
    const targetOption = selectedOptions[selectedOptions.length - 1]
    targetOption.loading = true
  }
    const [labelList, setLabelList] = useState<any>([])
      const labelData = () => {
        dispatch(
          getLabelList({
            current: 1,
            size: 1000,
          })
        )
          .then(unwrapResult)
          .then((res) => setLabelList(res.records))
      }

  useEffect(() => {
    if (Object.keys(storageParams).length && state == storageParams.state) {
      form.setFieldsValue({
        ...storageParams,
        endTimeHead: storageParams.createStartTime,
        endTimeTail: storageParams.createEndTime,
      })
    }
    form.submit()
  }, [])

  useEffect(() => {
    //获取省市数据
    dispatch(getAllList())
      .then(unwrapResult)
      .then((t: any) => {
        setAllList(t)
      })
  }, [])

  const getPageList = () => {
    setPageLoading(true)
    dispatch(
      getServerList({
        ...params,
        area: undefined,
        provinceCode: params?.area?.slice(0, 1)[0],
        cityCode: params?.area?.slice(1, 2)[0],
        countyCode: params?.area?.slice(2, 3)[0],
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          total: res.total,
          items: res.records,
        })
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    params.current &&
      sessionStorage.setItem(
        location.pathname,
        JSON.stringify({ ...params, state })
      ) //数据缓存
  }, [params, state])
  useEffect(() => {
    if (params.current != 0) {
      getPageList()
    }
  }, [params])

  useEffect(() => {
    //产品价格
    dispatch(getOrderPriceList())
      .then(unwrapResult)
      .then((res: any) => setProductPriceModalList(res))
  }, [])

    useEffect(() => {
      dispatch(
        getPlatformIdList({
          current: 1,
          size: 100,
        })
      )
        .then(unwrapResult)
        .then((res: any) => {
          setPlatformIdOptions(res.records)
        })
      labelData()
    }, [])

  return (
    <>
      <div className={styles.wrap}>
        {/* 筛选查询区域 */}
        <Form
          form={form}
          autoComplete='off'
          onFinish={(values) => {
            setParams({
              ...params,
              ...values,
              tenantCategory:
                values.tenantCategory === TenantCategory.All
                  ? undefined
                  : values.tenantCategory,
              deadLineStart: values.endTimeHead,
              deadLineEnd: values.endTimeTail,
              endTimeHead: undefined,
              endTimeTail: undefined,
              current: 1,
            })
          }}
        >
          <Row
            justify='space-between'
            align='middle'
            className={styles.queryWrap}
          >
            <Space>
              <Form.Item
                name='tenantName'
                noStyle
                getValueFromEvent={stringTrim}
              >
                <Input
                  allowClear
                  placeholder='请输入机构名称'
                  prefix={<SearchOutlined />}
                  onChange={form.submit}
                />
              </Form.Item>

              <Form.Item name='productId' noStyle>
                <Select
                  placeholder='产品类型-全部'
                  style={{ width: '13rem' }}
                  onChange={form.submit}
                  allowClear
                >
                  {(() => {
                    const filteredProducts = productPriceModalList?.filter((el: any) => 
                      ['电子发票', '医保对接', 'VPN专线', '系统账号'].includes(el.productName)
                    ) || [];
                    const hasSystemAccount = filteredProducts.some((el: any) => el.productName === '系统账号');
                    const productsToShow = hasSystemAccount 
                      ? filteredProducts 
                      : [...filteredProducts, { id: 1, productName: '系统账号' }];
                    return productsToShow.map((el: any) => (
                      <Select.Option key={el.id} value={el.id}>
                        {el.productName}
                      </Select.Option>
                    ));
                  })()}
                </Select>
              </Form.Item>

              <Form.Item name='area' noStyle>
                <Cascaded
                  loadData={loadData}
                  changeOnSelect
                  suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  options={allList}
                  style={{ width: '13rem' }}
                  onChange={form.submit}
                  placeholder='请选择省市区'
                />
              </Form.Item>

              <Form.Item
                name='tenantIdList' noStyle
              >
                <Select
                  mode='tags'
                  suffixIcon={
                    <CaretDownFilled style={{ color: theme.tc3 }} />
                  }
                  allowClear
                  onChange={form.submit}
                  style={{ width: '8rem' }}
                  placeholder='标签-全部'
                >
                  {labelList.map((c: any) => (
                    <Select.Option key={c.id} value={c.id}>
                      {c.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <DateSelect
                options={[
                  DateRangeType.Today,
                  DateRangeType.Yesterday,
                  DateRangeType.ThisWeek,
                  DateRangeType.ThisMonth,
                  DateRangeType.NextMonth,
                  DateRangeType.ThisYear,
                  DateRangeType.Range,
                ]}
                style={{ width: '13rem' }}
                labelPrefix=''
                placeholder='到期日期'
                namePrefix='endTime'
                onChange={form.submit}
              />

              <Form.Item noStyle name='status'>
                <Select
                  style={{ width: '10rem' }}
                  placeholder='状态'
                  onChange={form.submit}
                  allowClear
                >
                  <Select.Option value={1}>有效</Select.Option>
                  <Select.Option value={0}>已过期</Select.Option>
                </Select>
              </Form.Item>

            </Space>
            <Button type='primary' onClick={form.submit}>
              查询
            </Button>
          </Row>
        </Form>

        {/* 表格区域 */}
        <div className={styles.tableWrap}>
          <EditableList
            page={{
              current: params.current,
              size: params.size,
              total: page.total,
              items: page.items,
            }}
            loading={pageLoading}
            className={styles.table}
            columns={orderColumns((t: any) => {
              console.log(t)
            }, params.size * (params.current - 1))}
            onChangePage={(current: number, size?: number) => {
              setParams({
                ...params,
                current,
                size,
              })
            }}
          />
        </div>
      </div>
    </>
  )
}
